import { DisplayFormat, FetchStatus, Property, PropertyType } from "../../../../base/types";
import { IAsyncBoundProperties, usePropertyDraftText } from "../../../../base/hooks";
import { useEffect, useState } from "react";

import { ITextProps } from "./ITextProps";
import { formatValue } from "../../../helpers";

export const TextProperties = [
    { id: Property.Text, name: 'Text', type: PropertyType.String },
    { id: Property.Format, name: 'Format', type: PropertyType.DisplayFormat },
    { id: Property.Tooltip, name: 'Tooltip', type: PropertyType.String }
]

export const useTextProperties = (props: IAsyncBoundProperties) => {
    const { status, result: bindings, error } = props;
    const draftText = usePropertyDraftText({ bindings, property: Property.Text })
    const [properties, setProperties] = useState<ITextProps>()

    useEffect(() => {
        if (status !== FetchStatus.Success || !bindings)
            return;

        const textValue = bindings.getValue<string>(Property.Text);
        const format = bindings.getValue<DisplayFormat>(Property.Format);
        const text = formatValue(textValue, format)
        const title = bindings.getValue<string>(Property.Tooltip);

        setProperties({ text, title })
        // eslint-disable-next-line
    }, [bindings, status]);

    return { status, error, bindings, properties, draftText }
}

